import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from "@angular/core";
import {
  statusClassWithCondition,
  TableColumn,
} from "src/app/services/model/tables.model";

@Component({
  selector: "app-table-widget",
  templateUrl: "./table-widget.component.html",
  styleUrl: "./table-widget.component.scss",
  standalone: false,
})
export class TableWidgetComponent {
  @Input() showCardHeader: boolean = false;
  @Input() tableLabel: string = "APP.ITEMS";
  @Input() buttonLabel: string = "APP.ADD";
  @Input() containerClass: string = "h-table-custom";
  @Input() showCardSpace: boolean = true;
  @Input() showHoverBg: boolean = true;
  @Input() rowClick: boolean = true;
  @Input() rowBorderBottom: boolean = true;
  @Input() scrollToTop: boolean = false;

  @Input() dataTable: boolean = false;

  @Input()
  set dataSource(value: any) {
    if (value) {
      this.sources = value;
    }
  }

  @Input() dataColumns: TableColumn[] = [];

  @Input() set isLoading(value: boolean) {
    this.loading = value;

    if (!this.loading && this.scrollToTop) {
      const element = document.getElementById("table_header");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" }); // scroll smoothly to the element
      }
    }
  }
  @Output() onRowClick = new EventEmitter();
  @Output() onButtonClick = new EventEmitter();
  @Output() tableChange = new EventEmitter();

  loading: boolean = true;
  sources: any;

  vertical_scrollbar: boolean = false;

  ngOnInit(): void {
    const table = document.getElementById("widget-table") as HTMLElement;

    if (!this.rowClick) {
      this.showHoverBg = false;
    }
  }

  objectKeyValue(prop: string | undefined) {
    return prop as string;
  }

  /** Position of `value` in the column's statuses; -1 when it is not listed (the template then falls back to muted). */
  statusIndex(index: number, value: any) {
    const column = this.dataColumns[index];
    if (this.isArray(column.statuses)) {
      return (column.statuses as number[]).findIndex(
        (status_id: number) => status_id === value
      );
    } else {
      return 0;
    }
  }

  mapConditionClass(
    value: string | number | boolean,
    statusArray: statusClassWithCondition[]
  ): statusClassWithCondition | undefined {
    return statusArray!.find(
      (i: statusClassWithCondition) => i.id === value || i.name === value
    );
  }
  clickedRow(event: MouseEvent, data: any) {
    const target = event.target as HTMLElement;

    if (target.closest('.no-click')) {
      return;
    }


    this.onRowClick.emit(data);
  }

  isArray(key: any) {
    return Array.isArray(key);
  }

  onTableChange(event: Event) {
    this.tableChange.emit(event);
  }
  onClick() {
    this.onButtonClick.emit(true);
  }
}
